// @flow

import _ from "lodash"

type AdviceType = "health" | "visa" | "passport"

type AdviceStatus = "critical" | "notice" | "ok" | "not_needed" // not sure about not_needed being used

export type Advice = {
  country: string,
  info: string,
  status: AdviceStatus,
  timestamp: number,
  type?: AdviceType,
}

type Input = {
  [key: number]: {
    health: Array<Advice>,
    passport: Array<Advice>,
    visa: Array<Advice>,
  },
}

type Output = Array<{
  country: string,
  status: AdviceStatus,
  type: AdviceType,
  info: string,
  timestamp: number,
}>

export default function(input: Input): Output {
  const advices = []
  const uniqCountries = {
    visa: [],
    health: [],
    passport: [],
  }

  _.forEach(input, trip => {
    _.forEach(trip, (arr, type) => {
      _.forEach(arr, x => {
        // Right now, we care just about Visas
        if (type === "visa" || type === "health") {
          const country = x.country.toLowerCase()
          if (!~uniqCountries[type].indexOf(country)) {
            uniqCountries[type].push(country)
            advices.push(
              Object.assign(x, {
                type,
                country,
              }),
            )
          }
        }
      })
    })
  })
  return advices
}
